import { useCallback, useEffect, useState } from 'react';

import { useOfferContext } from '../../../../../context';
import { getChatOnboardingCookie, setChatOnboardingCookie } from '../../../../../utils/chatOnboarding';

const OFFER_CHAT_ONBOARDING_COOKIE_KEY = 'frontend-serp.offer_chat_onboarding_shown';

interface IOnboardingTooltipResult {
  open: boolean;
  closeHandler: () => void;
}

export const useOfferChatOnboarding = (): IOnboardingTooltipResult => {
  const { offer, chatOnboarding } = useOfferContext();
  const [open, setOpen] = useState(false);

  const closeHandler = useCallback(() => {
    setOpen(false);
    setChatOnboardingCookie(OFFER_CHAT_ONBOARDING_COOKIE_KEY);
  }, []);

  const canShowForOffer = chatOnboarding?.offerIdForOfferChatOnboarding === offer.id;
  const chatWasOpened = chatOnboarding?.wasOfferChatOpened;

  useEffect(() => {
    if (canShowForOffer && !getChatOnboardingCookie(OFFER_CHAT_ONBOARDING_COOKIE_KEY)) {
      setOpen(true);
    }
  }, [canShowForOffer]);

  useEffect(() => {
    if (open && chatWasOpened) {
      closeHandler();
    }
  }, [open, chatWasOpened, closeHandler]);

  return {
    open,
    closeHandler,
  };
};
